module.exports = __webpack_public_path__ + "img/haibao.a9590134.png";